import { Box } from '@mui/material'

import { type EventDTO, VerticalCard } from '~entities/index'

export const OneCardGroup = ({ type, events }: { type: 1 | 2; events: EventDTO[] }) => {
	const isMain = type === 1

	return (
		<Box
			minWidth={type === 1 ? '600px' : '320px'}
			maxWidth={type === 1 ? '600px' : '320px'}
			height={type === 1 ? '800px' : '384px'}
			display={'flex'}
		>
			<VerticalCard
				info={events[0]}
				isMain={isMain}
				isSmall={!isMain}
			/>
		</Box>
	)
}
